import { useTranslation } from "react-i18next";
import { Badge, styled } from "@mui/material";
import { formatInboxDatetime } from "utils/formatInboxDatetime";
import { useInboxContext } from "context/InboxProvider";
import AvatarCustom from "../../../AvatarCustom/AvatarCustom";
import SmallText from "../../../Typography/SmallText";
import NotificationDropdown from "./NotificationDropdown";

const ContainerStyled = styled("div")({
  width: "100%",
  display: "flex",
  alignItems: "flex-start",
  borderRadius: "0.5rem",
  padding: "0.5rem",
  marginTop: "0.5rem",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#fafafa",
  },
  "& .time": {
    lineHeight: "16px",
    color: "#424242",
  },
  "& .left-col": {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "0.5rem",
    marginRight: "0.75rem",
  },
  "& .content": {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem",
    "& .buttons": {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      "& button": {
        flex: 1,
      },
    },
  },
});
const NotificationContentContainer = ({ notification, children, onClick }) => {
  const { t } = useTranslation();
  const { readOne } = useInboxContext();
  const { user, createdAt, id, readAt } = notification || {};
  const name = user ? user.firstName + " " + user.lastName : undefined;
  const sentBefore = formatInboxDatetime(t, createdAt);

  const handleClick = () => {
    readOne(id);
    onClick?.();
  };

  return (
    <ContainerStyled onClick={handleClick}>
      {user && (
        <div className="left-col">
          {readAt ? (
            <AvatarCustom name={name} sx={{ width: "32px", height: "32px" }} />
          ) : (
            <Badge variant="dot" color="primary">
              <AvatarCustom
                name={name}
                sx={{ width: "32px", height: "32px" }}
              />
            </Badge>
          )}
          <SmallText className="time">{sentBefore}</SmallText>
        </div>
      )}
      <div className="content">{children}</div>
      <NotificationDropdown id={id} />
    </ContainerStyled>
  );
};

export default NotificationContentContainer;
